import { createContext } from 'react';
import { App } from '../App';
import Bet from '../Bet';
import '../i18n';
export const appContext = createContext<App>({} as App);
export const betContext = createContext<Bet>({} as Bet);
